































































































import { defineComponent, computed, onMounted, onUnmounted } from '@vue/composition-api';
import Chart from '@/renderer/components/charts/Chart.vue';
import userHandler from './compositions/userHandler';
import { upgradeName, goUpgrade } from '../statisticsHandler';
export default defineComponent({
  components: {
    Chart,
  },
  setup(props, context) {
    const store = context.root.$store;
    const { chartLoading, chartOptions, getSpaceStats } = userHandler();
    const userCountInfo = computed(() => store.getters.userCountInfo);
    getSpaceStats();
    reporter.report('value_added', {
      user_number_show: 'management_center_user_number_button',
    });

    const updateUserCountInfoTimerFunc = () => {
      store.dispatch('getUserCount');
    };

    let updateUserConutInfoTimer: number | undefined;
    onMounted(() => {
      // 每5分钟更新一下数据
      updateUserConutInfoTimer = window.setInterval(updateUserCountInfoTimerFunc, 300000);
    });
    onUnmounted(() => {
      if (updateUserConutInfoTimer) {
        window.clearInterval(updateUserConutInfoTimer);
        updateUserConutInfoTimer = undefined;
      }
    });
    return {
      userCountInfo,
      chartLoading,
      chartOptions,
      upgradeName,
      goUpgrade,
    };
  },
});
